<template>
  <AppLayout>
    <div class="details-layout">
      <v-flex v-if="Object.keys(selectedHouse).length > 0" sm12>
        <template>
          <v-toolbar color="white" class="elevation-0">
            <v-toolbar-side-icon>
              <v-chip style="font: bolder; color: darkred;">{{selectedHouse.id}}</v-chip>
            </v-toolbar-side-icon>
            <v-toolbar-side-icon>
              <v-icon large color="primary">location_on</v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-title class="subtitle">
              {{ address }}
            </v-toolbar-title>
            <v-spacer />
            <v-tooltip bottom v-if="$vuetify.breakpoint.mdAndUp">
              <template v-slot:activator="{ on }">
                <v-btn flat icon color="primary" @click.stop="close()" v-on="on">
                  <v-icon class="mr-1">close</v-icon>
                </v-btn>
              </template>
              <span>Close house details</span>
            </v-tooltip>
            <v-btn flat icon color="primary" @click.stop="close()" v-else>
              <v-icon class="mr-1">close</v-icon>
            </v-btn>

          </v-toolbar>
          <v-toolbar color="white" class="elevation-0">
            <v-toolbar-title class="subtitle" style="padding-left: 20px; width:90%; color:red">
              <v-text-field v-model="houseNote" placeholder="house note" >
                <template v-slot:append v-if="savable">
                  <v-btn icon @click="saveHouseNote()" :disabled="selectedHouse.note === houseNote">
                    <v-icon class="primary--text">save</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-toolbar-title>
          </v-toolbar>

          <Menu />
          <v-card class="elevation-0 details-layout__content">
            <v-card-text>
              <v-container grid-list-md px-0>
                <v-layout row wrap>
                  <v-flex sm3 class="details-layout__menu details-layout__menu--vertical">
                    <v-navigation-drawer
                      v-if="Object.keys(hhsTasks).length > 0 && isHHSPage()"
                      permanent
                      stateless
                    >
                     <v-subheader key="subheader">HHS inspections</v-subheader>
                        <v-divider key="divide"/>
                      <template v-for="(item, index) in menuItems">
                        <v-list :key="index">
                          <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title class="menu-item">
                              <router-link
                                :to="{ path: ''+item.meta.params.id  }"
                                class="body-1"
                              >
                                  {{ item.meta.menuTitle }}
                              </router-link>
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </template>
                    </v-navigation-drawer>
                    <v-navigation-drawer
                      v-else-if="Object.keys(inspectionTasks).length > 0 && isNewInspectionPage()"
                      permanent
                      stateless
                    >
                     <v-subheader key="subheader">Regular inspections</v-subheader>
                        <v-divider key="divide"/>
                      <template v-for="(item, index) in menuItems">
                        <v-list :key="index">
                          <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title class="menu-item">
                              <router-link
                                :to="{ path: ''+item.meta.params.id  }"
                                class="body-1"
                              >
                                  {{ item.meta.menuTitle }}
                              </router-link>
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </template>
                    </v-navigation-drawer>
                    <v-navigation-drawer
                      v-else
                      permanent
                      stateless
                    >
                      <template v-for="(item, index) in menuItems">
                        <v-list :key="index">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title class="menu-item">
                              <router-link
                                :to="{ name: item.name }"
                                class="body-1"
                              >
                                {{ item.meta.menuTitle }}
                              </router-link>
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                      </template>
                    </v-navigation-drawer>
                  </v-flex>
                  <v-flex sm9 class="pa-3">
                    <slot />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </template>
      </v-flex>
    </div>
  </AppLayout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import AppLayout from '@/views/AppLayout'
import Menu from '@/components/houselist/DetailsMenu'


export default {
  name: 'HouseDetailsLayout',
  components: { AppLayout, Menu },
  data() {
    return {
      menuItems: [],
      houseNote: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedHouse: 'HouseList/getSelectedHouse',
      inspections: 'HouseList/Inspections/getAll',
      currentUser: 'User/getUser',
//      tasks: 'Tasks/getAllTasks',
    }),
    tasks() {
      return this.selectedHouse.task;
    },
    address() {
      let address = ''

      if (this.selectedHouse.unit) {
        address += this.selectedHouse.unit + '/'
      }

      if (this.selectedHouse.num) {
        address += this.selectedHouse.num + ' '
      }

      if (this.selectedHouse.street) {
        address += this.selectedHouse.street
      }

      return address
    },
    inspectionTasks() {
      return this.tasks.filter(t => t.title === 'inspections' && t.status >= 7)
              .sort((a, b) => a.timestamp - b.timestamp)
    },
    hhsTasks() {
      return this.tasks.filter(t => t.title === 'hhs' && t.status >= 7)
              .sort((a, b) => a.timestamp - b.timestamp)
    },
    savable() {
      return this.currentUser && this.currentUser.role && this.currentUser.role.includes('PropertyManager')
    }
  },
  watch: {
    $route(to, from) {
      console.log('route changed', to)
      this.setMenuItems(to)

      if (this.selectedHouse) {
        this.houseNote = this.selectedHouse.note
      }
    }
  },
  mounted() {
    this.setMenuItems()
    if (this.selectedHouse) {
      this.houseNote = this.selectedHouse.note
    }
  },
  methods: {
    ...mapActions({
      update: 'HouseList/updateHouse'
    }),
    save() {
      if (this.savable) {
        this.update(this.selectedHouse)
      }
    },
    saveHouseNote() {
      if (!this.savable) {
        return;
      }
      if (this.selectedHouse && this.selectedHouse.note !== this.houseNote) {
        this.update({ id: this.selectedHouse.id, note: this.houseNote})
        this.selectedHouse.note = this.houseNote
      }
    },
    close() {
      this.$router.push({ name: 'houses' })
    },
    isAdmin() {
      console.log('this.currentUser', this.currentUser)
      return this.currentUser && this.currentUser.role && this.currentUser.role.includes('Admin')
    },
    setMenuItems(to) {
      console.log('setMenuItems', to)
      let context = 'houseDetailInfo'

      // Reset menuItems
      if (this.menuItems.length > 0) {
        this.menuItems.length = 0
      }

      // If we land on a route then we should use the route information
      if (!to) {
        context = this.$route.meta.menuGroup
      } else if (typeof to.meta.menuGroup !== 'undefined') {
        context = to.meta.menuGroup
      }

      if (context === 'hhsTasks') {
        Object.values(this.hhsTasks).forEach(task => {
          this.menuItems.push({
            meta: {
              name: 'hhsTasks',
              menuTitle: moment.unix(task.timestamp).format('YYYY-MM-DD'),
              params: { id: task.id }
            }
          })
        })
      } else if (context === 'inspectionTasks') {
        Object.values(this.inspectionTasks).forEach(task => {
          const route = {
            meta: {
              name: 'inspectionTasks',
              menuTitle: moment.unix(task.timestamp).format('YYYY-MM-DD'),
              params: { id: task.id  }
            }
          };
          this.menuItems.push(route)
        })
      } else {
        this.$router.options.routes.forEach((route) => {
          this.getChildRoutes(route, context)
        })
      }
    },
    getChildRoutes(route, key) {
      console.log('getChildRoutes', route)
      if (typeof route.children !== 'undefined') {
        route.children.forEach(child => this.getChildRoutes(child, key))
      } else {
        if (typeof route.meta !== 'undefined' && route.meta.menuGroup === key) {
          this.menuItems.push(route)
        }
      }
    },
    isInspectionsPage() {
      return this.$route.name === 'houseDetailInspections'
    },
    isHHSPage() {
      return this.$route.name === 'hhsTasks'
    },
    isNewInspectionPage() {
      return this.$route.name === 'inspectionTasks'
    },
    inspectionDate(timestamp) {
      return moment.unix(timestamp).format("YYYY-MM-DD")
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~vuetify/src/stylus/settings/_colors';

  .details-layout {
    max-width: 1250px;
    margin: 0 auto;
  }

  .details-layout__content {
    border-top: 1px solid $grey.lighten-2;
  }

  .v-toolbar__title {
    margin-left: 0;
    font-size: 24px !important;
  }
  .v-toolbar__subtitle {
    margin-left: 0;
    color: red;
    font-size: 24px !important;
  }

  .details-layout__menu .menu-item .router-link-exact-active, .payments-layout__menu .menu-item .router-link-exact-active {
      color: var(--v-primary-base);
      padding-bottom: 1px;
  }
</style>
